export const environment = {
  production: false,
  apiUrl: `${(window as any).environments.apiUrlDev}`,
  apiUrlV2: `${(window as any).environments.apiUrlDev}/v2`,
  arimedDoctorAppUrl: `${(window as any).environments.doctorAppUrlDev}`,
  doctors4uaAppUrl: `${(window as any).environments.doctorAppUrlDev}`,
  socketApi: 'wss://centrifugo.doctors4ua.com/connection/websocket',
  portalApi: `https://develop.doctors4ua.com`,
  siteKey: '6LfQOkwhAAAAAMSC2o4ZbWUEmMZ4LHV37A27IZ2o',
  loggerConfig: {
    // socket (centrifugo)
    socketInfo: true,
    socketError: true,
    // mediaChat
    mediaChatInfo: true,
    mediaChatError: true,
    // notification
    notificationInfo: true,
    // onlineChat
    onlineChatInfo: true,
    // dialogueChat
    dialogueInfo: true,
    // sidebar
    sidebarInfo: true,
    // waitingArea
    waitingAreaInfo: true,
    // searchDoctor
    searchDoctorInfo: true
  }
};
